<div class="container-fluid p-0 edit-profile-page" data-bs-theme="dark">

    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="show_assistant = true"
    />

    <section class="container profile-sections py-4">

        <!-- HERO -->
        <div class="card pv-card border-0 overflow-hidden mb-4">
            <div class="pv-cover"></div>

            <div class="card-body px-4 pb-4 pt-0">
                <div class="d-flex flex-column flex-md-row align-items-center align-items-md-end gap-3 gap-md-4 text-center text-md-start">
                    <div class="pv-avatar text-bg-warning rounded-4 d-flex align-items-center justify-content-center flex-shrink-0">
                        {{ avatar_initials }}
                    </div>

                    <div class="flex-grow-1 pb-md-1">
                        <h2 class="fw-bold text-white mb-1">{{ page_title }}</h2>
                        <p class="text-body-secondary mb-0">{{ page_description }}</p>
                    </div>

                    <button
                        type="button"
                        class="btn btn-outline-light btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                        @click="cancelEdit"
                        :disabled="is_saving"
                    >
                        <i class="bi bi-arrow-left"></i> Back
                    </button>
                </div>
            </div>
        </div>

        <div class="row g-4">

            <!-- FORM -->
            <div class="col-lg-8">
                <form class="card pv-card border-0 h-100" @submit.prevent="saveProfile">
                    <div class="card-header bg-transparent border-bottom border-secondary-subtle px-4 py-3">
                        <h6 class="mb-0 fw-semibold text-white">
                            <i class="bi bi-person-lines-fill text-warning me-2"></i>Personal Information
                        </h6>
                    </div>

                    <div class="card-body p-4">
                        <div v-if="form_error" class="alert alert-danger d-flex align-items-center gap-2 rounded-3" role="alert">
                            <i class="bi bi-exclamation-triangle-fill"></i>
                            <span>{{ form_error }}</span>
                        </div>

                        <div v-if="is_loading" class="d-flex align-items-center gap-2 text-body-secondary mb-3">
                            <div class="spinner-border spinner-border-sm text-warning" role="status" aria-hidden="true"></div>
                            <small>Loading user details...</small>
                        </div>

                        <div class="row g-4">
                            <div class="col-md-6">
                                <label for="edit-profile-first-name" class="form-label small fw-semibold text-body-secondary">First name</label>
                                <div class="input-group input-group-lg">
                                    <span class="input-group-text bg-transparent text-warning"><i class="bi bi-person"></i></span>
                                    <input
                                        id="edit-profile-first-name"
                                        type="text"
                                        class="form-control bg-transparent"
                                        placeholder="e.g. Thandi"
                                        v-model="form.first_name"
                                        :disabled="is_loading || is_saving"
                                        required
                                    >
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="edit-profile-last-name" class="form-label small fw-semibold text-body-secondary">Last name</label>
                                <div class="input-group input-group-lg">
                                    <span class="input-group-text bg-transparent text-warning"><i class="bi bi-person-vcard"></i></span>
                                    <input
                                        id="edit-profile-last-name"
                                        type="text"
                                        class="form-control bg-transparent"
                                        placeholder="e.g. Nkosi"
                                        v-model="form.last_name"
                                        :disabled="is_loading || is_saving"
                                        required
                                    >
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="edit-profile-email" class="form-label small fw-semibold text-body-secondary">Email address</label>
                                <div class="input-group input-group-lg">
                                    <span class="input-group-text bg-transparent text-warning"><i class="bi bi-envelope"></i></span>
                                    <input
                                        id="edit-profile-email"
                                        type="email"
                                        class="form-control bg-transparent"
                                        v-model="form.email"
                                        aria-describedby="edit-profile-email-help"
                                        readonly
                                        disabled
                                    >
                                    <span class="input-group-text bg-transparent text-warning"><i class="bi bi-lock-fill text-body-tertiary"></i></span>
                                </div>
                                <div id="edit-profile-email-help" class="form-text">Email address can't be changed.</div>
                            </div>

                            <div class="col-md-6">
                                <label for="edit-profile-phone" class="form-label small fw-semibold text-body-secondary">Phone number</label>
                                <div class="input-group input-group-lg">
                                    <span class="input-group-text bg-transparent text-warning"><i class="bi bi-telephone"></i></span>
                                    <input
                                        id="edit-profile-phone"
                                        type="tel"
                                        name="phone"
                                        pattern="[0-9]{10}"
                                        placeholder="0123456789"
                                        class="form-control bg-transparent"
                                        aria-describedby="edit-profile-phone-help"
                                        v-model="form.phone"
                                        :disabled="is_loading || is_saving"
                                        required
                                    >
                                </div>
                                <div id="edit-profile-phone-help" class="form-text">10 digits, no spaces.</div>
                            </div>

                            <div class="col-md-6">
                                <label for="edit-profile-session" class="form-label small fw-semibold text-body-secondary">Session</label>
                                <select id="edit-profile-session" v-model="form.session_policy" class="form-select form-select-lg bg-transparent" :disabled="is_loading || is_saving">
                                    <option value="default">Default session</option>
                                    <option value="custom">Custom session</option>
                                    <option value="unlimited">Unlimited session</option>
                                </select>
                            </div>

                            <div v-if="form.session_policy === 'custom'" class="col-md-6">
                                <label for="edit-profile-session-timeout" class="form-label small fw-semibold text-body-secondary">Session timeout (minutes)</label>
                                <input id="edit-profile-session-timeout" v-model.number="form.session_timeout_minutes" type="number" min="1" step="1" class="form-control form-control-lg bg-transparent" :disabled="is_loading || is_saving" required>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer bg-transparent border-top border-secondary-subtle px-4 py-3 d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-2">
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                            @click="cancelEdit"
                            :disabled="is_saving"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            class="btn btn-warning fw-semibold btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
                            :disabled="is_loading || is_saving"
                        >
                            <span v-if="is_saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <i v-else class="bi bi-check2"></i>
                            <span>{{ is_saving ? 'Saving...' : 'Save Changes' }}</span>
                        </button>
                    </div>
                </form>
            </div>

            <!-- LIVE PREVIEW -->
            <div class="col-lg-4">
                <div class="card pv-card border-0 h-100">
                    <div class="card-header bg-transparent border-bottom border-secondary-subtle px-4 py-3">
                        <h6 class="mb-0 fw-semibold text-white">
                            <i class="bi bi-eye text-warning me-2"></i>Preview
                        </h6>
                    </div>

                    <div class="card-body p-4 text-center">
                        <div class="pv-avatar pv-avatar-sm text-bg-warning rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
                            {{ avatar_initials }}
                        </div>
                        <h5 class="fw-bold text-white mb-1 text-break">
                            {{ preview_name || 'Your name' }}
                        </h5>
                        <p class="small text-body-secondary mb-4 text-break">{{ form.email || '—' }}</p>

                        <ul class="list-group list-group-flush text-start">
                            <li class="list-group-item bg-transparent px-0 d-flex align-items-center gap-2 small">
                                <i class="bi bi-telephone text-warning"></i>
                                <span v-if="form.phone" class="text-white">{{ form.phone }}</span>
                                <span v-else class="text-body-tertiary fst-italic">No phone number yet</span>
                            </li>
                        </ul>

                        <div class="alert alert-warning bg-warning-subtle border-warning-subtle text-warning-emphasis small text-start d-flex gap-2 mt-3 mb-0 rounded-3">
                            <i class="bi bi-lightbulb"></i>
                            <span>A current phone number makes it easier to get in touch about this account.</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- VSI Assist -->
    <BolideAssistant :is_open="show_assistant" @close-assistant="show_assistant = false" />

</div>
